<template>
  <div
    class="newJD-right-innerContent-preview maincvs-container"
    id="scrollToTop"
  >
    <b-row class="m-0 padding-15-25">
      <b-col cols="6" class="d-flex align-items-center p-0"></b-col>
      <b-col cols="6" class="text-right p-0">
        <span
          v-if="!showcvsmedia"
          class="
            viewvideo-font
            ml-2
            pointer
            d-flex
            align-items-center
            justify-content-end
          "
          @click="showcvsmedia = true"
        >
          <img src="@/assets/img/video.svg" class="pointer mr-2" alt="" />
          View Video
        </span>
        <span
          v-else
          class="
            viewvideo-font
            ml-2
            pointer
            d-flex
            align-items-center
            justify-content-end
          "
          @click="showcvsmedia = false"
        >
          <img
            src="@/assets/new-kanban-icons/view-id.svg"
            class="pointer mr-2"
            alt=""
          />
          View ID Proof
        </span>
      </b-col>
    </b-row>
    <b-row class="padding-0-25">
      <b-col>
        <div v-if="showcvsmedia" class="cvs-media-container rounded">
          <div
            v-if="!videoProcessed(candidatecvsdata[selectedCvsIndex])"
            class="cvs-black-screen"
          >
            <div class="white-bar-loader">
              <div v-for="i in 8" :key="i"></div>
            </div>
            <div class="text-white-1">Video Processing...</div>
            <div class="text-white-2">Please come back in some time</div>
          </div>
          <video
            v-else
            :src="candidatecvsdata[selectedCvsIndex].candidateVideo"
            id="video"
            class="w-100 h-100 overflow-hidden rounded"
            alt=""
            controls
          />
        </div>
        <div class="cvs-media-container rounded" v-else>
          <img
            :src="candidatecvsdata[selectedCvsIndex].candidateImage"
            class="rounded w-100 overflow-hidden h-100"
            alt=""
          />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="padding-0-40">
        <section
          v-if="showMatchBar"
          class="
            d-flex
            cvs-identity-box
            fs-13
            fw-500
            font-lato font-italic
            color-595959
            text-center
            mt-3
          "
          :class="
            hasBoth ? 'justify-content-between' : 'justify-content-center'
          "
        >
          <span
            v-if="
              candidatecvsdata[selectedCvsIndex].comparisonScore ||
              candidatecvsdata[selectedCvsIndex].comparisonScore == 0
            "
          >
            Face Match Rating:&nbsp;
            <span class="font-normal color-mainblue fw-700 fs-14">
              {{
                Math.round(candidatecvsdata[selectedCvsIndex].comparisonScore)
              }}%</span
            >
          </span>
          <span v-if="isValidCVSDocument">
            ID Type:&nbsp;
            <span class="font-normal color-mainblue fw-700 fs-14">
              {{ candidatecvsdata[selectedCvsIndex].stats.documentType }}</span
            >
          </span>
        </section>
      </b-col>
    </b-row>
    <section class="padding-13">
      <section
        v-for="(asmntdetails, index) in candidatecvsdata[selectedCvsIndex]
          .answerResponse"
        :key="asmntdetails.questionKey"
        class="inner-cvs-ques"
        :class="asmntdetails.timeStamp && 'ques-hover pointer'"
        :style="index != 0 && 'margin-top: 1rem'"
        @click="asmntdetails.timeStamp ? vidplay(asmntdetails.timeStamp) : ''"
      >
        <b-row class="m-0 mt-2">
          <b-col class="p-0 question-no-font" cols="6"
            >Question {{ index + 1 }}:</b-col
          >
          <b-col class="p-0 d-flex justify-content-end" cols="6">
            <div class="pass-card" style="width: 70px; background: #f6f9fb">
              <img src="@/assets/img/smallest-AI.svg" class="mr-1" alt="" />
              {{ asmntdetails.score || "0" }}/10
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-1 m-0">
          <b-col class="p-0 quest-subhead">{{ asmntdetails.question }}</b-col>
        </b-row>
        <b-row class="m-0 mt-2">
          <b-col class="p-0 question-no-font" cols="6"
            >Answer {{ index + 1 }}:</b-col
          >
        </b-row>
        <b-row class="mt-1 m-0">
          <b-col class="p-0 quest-subhead">{{
            asmntdetails.answer.text
          }}</b-col>
        </b-row>
        <hr
          v-if="
            index !==
            candidatecvsdata[selectedCvsIndex].answerResponse.length - 1
          "
        />
      </section>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showcvsmedia: false,
    };
  },
  props: {
    candidatecvsdata: Array,
    selectedCvsIndex: Number,
  },
  computed: {
    hasBoth() {
      const hasScore =
        this.candidatecvsdata[this.selectedCvsIndex]?.comparisonScore === 0 ||
        this.candidatecvsdata[this.selectedCvsIndex]?.comparisonScore;

      return hasScore && this.isValidCVSDocument;
    },
    showMatchBar() {
      return (
        this.candidatecvsdata[this.selectedCvsIndex].comparisonScore ||
        this.candidatecvsdata[this.selectedCvsIndex].comparisonScore == 0 ||
        this.isValidCVSDocument
      );
    },
    isValidCVSDocument() {
      const { documentType } =
        this.candidatecvsdata[this.selectedCvsIndex].stats;
      return (
        documentType &&
        documentType.toLowerCase() !== "n/a" &&
        documentType.toLowerCase() !== "unknown"
      );
    },
  },
  methods: {
    scrollTop(refVal) {
      const el = document.getElementById(refVal);
      if (el) {
        el.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    vidplay(value) {
      this.showcvsmedia = true;
      this.$nextTick(() => {
        let test = document.querySelectorAll("video");
        let data = value;

        let array = data.split(":");
        const [minutes, seconds] = array.map(Number);
        const totalSeconds = minutes * 60 + seconds;
        for (const item of test) {
          item.currentTime = totalSeconds;
        }
        this.scrollTop("scrollToTop");
      });
    },
    videoProcessed(cvs) {
      if (cvs.stats) return cvs.stats.videoProcessed;
      else return true;
    },
  },
};
</script>

<style>
.padding-15-25 {
  padding: 15px 25px;
}

.pass-card {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 10px;
  background: rgba(3, 142, 0, 0.1);
  border-radius: 4px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #038e00;
}

.question-no-font {
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 12px;
  color: #8c8c8c;
}

.quest-subhead {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}
.cvs-media-container {
  height: 265px;
  position: relative;
}
.padding-0-25 {
  padding: 0px 25px;
}

.cvs-black-screen {
  background-color: #000000;
  position: absolute;
  height: 265px;
  border-radius: 5px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
}
.cvs-black-screen .text-white-1 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
}
.cvs-black-screen .text-white-2 {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
}
.inner-cvs-ques {
  padding: 2px 12px 0px 12px;
}
.ques-hover:hover {
  background: #e8eff4 !important;
  border-radius: 8px;
  box-shadow: 0px 3px 8px 0px #0000002b;
}
.padding-13 {
  padding: 13px !important;
}
.maincvs-container {
  max-height: calc(100vh - 277px);
  padding: unset !important;
}
@media (max-width: 1028px) {
  .maincvs-container {
    max-height: calc(100vh - 150px);
  }
  .question-no-font {
    font-size: 11px;
  }
  .quest-subhead {
    font-size: 13px;
  }
  .pass-card {
    padding: 0 5px;
  }
  .padding-15-25 {
    padding: 15px 10px;
  }
  .padding-0-25 {
    padding: 0 10px;
  }
  .cvs-media-container {
    height: 206px;
  }
  .padding-13 {
    padding: 0 !important;
  }
}
.cvs-identity-box {
  padding: 4px 24px;
  width: 100%;
  background: rgba(32, 99, 155, 0.04);
  border: 1px solid rgba(32, 99, 155, 0.1);
  border-radius: 4px;
}
.padding-0-40 {
  padding: 0 40px;
}
</style>
